<template>
  <div>
    <div
      class="relative aos-init aos-animate"
      data-aos="fade-up"
      data-aos-duration="300"
    >
      <span
        class="absolute top-3 bg-orange-500 p-1 pe-6 text-sm font-semibold text-white"
        style="clip-path: polygon(0% 0%, 100% 0px, 90% 49%, 100% 99%, 0% 100%)"
      >
      </span
      ><img :src="blog.FeaturedImage" class="rounded-md" />
    </div>
    <p class="text-slate-500 mt-5">
      {{ timeFormatter(blog.UpdatedAt) }}
    </p>
    <h4 class="mt-1 text-lg">
      <a :href="blog.Slug"> {{ blog.Title }}</a>
    </h4>
  </div>
</template>

<script setup>
import { defineProps, toRefs } from "vue";
import { timeFormatter } from "@/services/contentService";

const props = defineProps({
  blog: Object,
});

const { blog } = toRefs(props);
</script>
